"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
exports.colors = [
    'blue100',
    'blue200',
    'blue300',
    'blue400',
    'blue500',
    'blue600',
    'blue700',
    'blue800',
    'blue900',
    'navy100',
    'navy200',
    'navy300',
    'navy400',
    'navy500',
    'navy600',
    'navy700',
    'navy800',
    'navy900',
];
//# sourceMappingURL=colors.js.map